import { Container } from '@pixi/react'
import { Button } from '../../UI/Button'
import { useChipSetStore } from '../../domain/chipSet/store/chipSetStore'
import { soundManager, SoundType } from '../../domain/sound/SoundManager'
import { chipSetService } from '../../domain/chipSet/service'

interface StakeControlPortraitProps {
  x: number
  y: number
  enabled: boolean
  clickPlusCallback?: () => void
  clickMinusCallback?: () => void
}

export const StakeControlPortrait = ({ ...props }: StakeControlPortraitProps) => {
  const chipSetStore = useChipSetStore()

  return (
    <Container name="StakeControlPortrait" position={[props.x, props.y]} height={78}>
      <Button
        name="minus button"
        defaultView="bet_minus_normal_portrail"
        hoverView="bet_minus_hover_portrail"
        disabledView="bet_minus_unable_portrail"
        pressedView="bet_minus_click_portrail"
        enabled={chipSetStore.computed.hasPrev && props.enabled}
        x={0}
        y={0}
        width={78}
        height={78}
        onPressing={() => {
          soundManager.play(SoundType.stake_minus)
        }}
        onPress={() => {
          chipSetService.selectPreviousChip()
          if (props.clickMinusCallback) {
            props.clickMinusCallback()
          }
        }}
      />

      <Button
        name="plus button"
        defaultView="bet_plus_normal_portrail"
        hoverView="bet_plus_hover_portrail"
        disabledView="bet_plus_unable_portrail"
        pressedView="bet_plus_click_portrail"
        enabled={chipSetStore.computed.hasNext && props.enabled}
        x={374}
        y={0}
        width={78}
        height={78}
        onPressing={() => {
          soundManager.play(SoundType.stake_plus)
        }}
        onPress={() => {
          chipSetService.selectNextChip()
          if (props.clickPlusCallback) {
            props.clickPlusCallback()
          }
        }}
      />
    </Container>
  )
}
